/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Exception } from '../../models/exception';

export interface HubsHubKioskOnDisconnectedAsyncPost$Params {
  exception?: Exception;
}

export function hubsHubKioskOnDisconnectedAsyncPost(http: HttpClient, rootUrl: string, params?: HubsHubKioskOnDisconnectedAsyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, hubsHubKioskOnDisconnectedAsyncPost.PATH, 'post');
  if (params) {
    rb.query('exception', params.exception, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

hubsHubKioskOnDisconnectedAsyncPost.PATH = '/hubs/HubKiosk/OnDisconnectedAsync';
